import React from 'react';

import { Group, Text } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

interface WeekAssignAffordanceProps {
  color: string;
  minHeight: number;
}

const WeekAssignAffordance = ({ color, minHeight }: WeekAssignAffordanceProps): JSX.Element => (
  <Group spacing={6} noWrap mt={6} align='center' mih={minHeight} sx={{ color }}>
    <IconPlus size={14} />
    <Text size='xs' fw={500}>
      Assign Workout
    </Text>
  </Group>
);

export default WeekAssignAffordance;
